import {  ContentFilters, ContentTopBar } from 'components';
import { useState } from 'react';
import { CompanyType } from 'types';

import { VehicleFilterFormValues } from './type';
import { VehicleFilterForm } from './vehicle-filter-form';


type MatrialTopBarProps = {
  getInitialFilterValues: VehicleFilterFormValues;
  handleFilter: (values: VehicleFilterFormValues) => void;
  userEditData: any;
  showAppUserModal:any;
  setShowAppUserModal:any
  onRefresh: () => void;
};

export const VehicleLoadingLogTopBar = ({
  getInitialFilterValues,
  handleFilter,
  onRefresh
}: MatrialTopBarProps) => {
  useState<CompanyType>();
  const formId = 'end-users-filters-form';
  
return (
    <>
      <ContentTopBar title={'Loading Vehicle'}/>
      <ContentFilters formId={formId}>
        <VehicleFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues as any}
          onRefresh={onRefresh}
        />
      </ContentFilters>
    </>
  );
};
